import { render } from "./TyreLabelRating.vue?vue&type=template&id=62c2036c"
import script from "./TyreLabelRating.vue?vue&type=script&lang=js"
export * from "./TyreLabelRating.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__